export default __webpack_public_path__ + "static/bg-hero-video-f085b5fe4e24c5911599ef52a18cf60c.mp4";